export function updateMapPinPosition( mapElement, long, lat ) {
	if (
		mapElement &&
		mapElement.leafletMapObject &&
		mapElement.leafletMapDefaultMarker
	) {
		mapElement.leafletMapDefaultMarker.setLatLng( [ lat, long ] );
		mapElement.leafletMapObject.panTo( [ lat, long ] );
	}
}
